export default {
  pageTitle: {
    id: 'models_comparison_page_title',
    defaultMessage: 'Compare models',
  },
  resultsTitle: {
    id: 'models_comparison_result_title',
    defaultMessage: '{firstModel} Vs {secondModel}',
  },
  shopCategory: {
    id: 'models_comparison_shop_category',
    defaultMessage: 'Shop {category}',
  },
  stickyHeader: {
    id: 'models_comparison_sticky_header_label',
    defaultMessage: 'Comparison summary',
  },
} as const
